import mime from "mime";
import { Path } from "utility";

export const isJson = (mimeType: string) => mimeType.indexOf("/json") > 0 ||  mimeType.indexOf("+json") > 0;

const mappings = {
    "text/x.nunjucks": "njk"
}

export enum FileType {
    Text, JsonInstance, Directory, Image, Binary, Zip
}

export class RsMime {
    getExtension(mimeType: string): string | null {
        if (mimeType.startsWith("application/schema-instance+json")
            || mimeType.startsWith("application/schema+json")) {
            return "json";
        }
        if (mappings[mimeType]) {
            return mappings[mimeType];
        }
        return mime.getExtension(mimeType);
    }

    getType(path: string): string | null {
        let mimeType = mime.getType(path);
        if (mimeType) return mimeType;

        const ext = path.indexOf('.') >= 0 ? (new Path(path)).extension : path;
        const entry = Object.entries(mappings).find(([, value]) => value === ext);
        return (entry ? entry[0] : null);
    }

    getCategory(mimeType: string): FileType {
        const simpleMimeType = mimeType ? mimeType.split(';')[0] : '';

        switch (simpleMimeType) {
            case "application/javascript":
                return FileType.Text;
            case "application/schema-instance+json":
                return FileType.JsonInstance;
            case "inode/directory+json":
                return FileType.Directory;
            case "application/zip":
                return FileType.Zip;
            default:
                if (simpleMimeType.startsWith("image/")) {
                    return FileType.Image;
                } else if (simpleMimeType.startsWith("text/") || simpleMimeType.endsWith("json")) {
                    return FileType.Text
                } else {
                    return FileType.Binary;
                }
        }
    }

    isText(mimeType: string): boolean {
        return [ FileType.Text, FileType.JsonInstance, FileType.Directory ].indexOf(this.getCategory(mimeType)) >= 0;
    }
}